export default "__VITE_ASSET__DQPfMxqn__"